<template>
  <div class="flex items-center justify-between gap-x-2 px-8 py-8 sticky top-0 bg-gray-100 z-50">
    <h3 class="font-semibold text-blue-600 text-xl">
      {{ title }}
    </h3>
    <button
      type="button"
      @click="emits('close')"
    >
      <XCircleIcon class="h-8 w-8 md:h-6 md:w-6 text-gray-600" />
    </button>
  </div>
</template>

<script setup>
import { XCircleIcon } from '@heroicons-2/vue/24/outline'

const emits = defineEmits(['close'])

const props = defineProps({
  title: {
    type: String,
    required: true
  }
})
</script>
